/**
 * タッチ主体の UI かどうか（マウス操作向け UI との切り替え用）。
 * Windows のタッチ対応 PC では maxTouchPoints だけだと常にタッチ扱いになるため、
 * pointer / hover メディアクエリを優先する。
 */
export function detectTouchDevice(): boolean {
  if (typeof window.matchMedia === 'function') {
    const fine = window.matchMedia('(pointer: fine)').matches;
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    const hover = window.matchMedia('(hover: hover)').matches;

    // マウス + ホバー可能 → デスクトップ操作
    if (fine && hover) {
      return false;
    }
    // タッチのみ
    if (coarse && !fine) {
      return true;
    }
  }

  return 'ontouchstart' in window && navigator.maxTouchPoints > 0;
}

export function isWindowsPwa(): boolean {
  if (!/Windows/i.test(navigator.userAgent)) {
    return false;
  }
  try {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.matchMedia('(display-mode: window-controls-overlay)').matches ||
      (window.navigator as Navigator & { standalone?: boolean }).standalone === true
    );
  } catch {
    return false;
  }
}
